import { makeObservable, observable, action, flow } from 'mobx';
import { SpecialServicingService } from '../services/specialServicingService';
import { GlobalStore, GridStore } from '@roc/feature-app-core';
import { PrincipalAmortizationTabs } from '../utils/constants';

const PAGE_SIZE = 400;

export class PrincipalAmortizationStore {
  globalStore: GlobalStore;
  service: SpecialServicingService;
  principalAmortizationGridStore: GridStore;
  loan: any;
  selectedRecord: any;
  showSelectedRecords = false;
  tab: PrincipalAmortizationTabs;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.service = new SpecialServicingService();
    this.principalAmortizationGridStore = new GridStore(() => this.fetchDashboard(), null, PAGE_SIZE);
    this.principalAmortizationGridStore.gridData.meta.pageSize = PAGE_SIZE;

    this.tab = PrincipalAmortizationTabs.AMORTIZATION;
    makeObservable(this, {
      loan: observable,
      setLoan: action,
      selectedRecord: observable,
      showSelectedRecords: observable,
      resetToolbarInfo: action,
      tab: observable,
      setTab: action,
    });
  };

  fetchDashboard = async () => {
    switch (this.tab) {
      case PrincipalAmortizationTabs.AMORTIZATION:
        if (this.loan)
          return await this.fetchServicingTransfersDashboard();
    }
  }

  fetchServicingTransfersDashboard = async () => {
    try {
      this.principalAmortizationGridStore.gridData.meta.pageSize = PAGE_SIZE;
      const filters = {
        ...this.principalAmortizationGridStore.gridData.meta.filters
      };
      const dropdownFilters = {
        loanId: this.loan?.loanId,
        ...this.principalAmortizationGridStore.gridData.meta.dropdownFilters
      };
      return await this.service.getLoanAmortizationDetails(
        this.loan?.loanId,
        this.principalAmortizationGridStore.gridData.meta.pageNumber,
        PAGE_SIZE,
        this.principalAmortizationGridStore.gridData.meta.sortDir,
        this.principalAmortizationGridStore.gridData.meta.sortBy,
        filters,
        this.showSelectedRecords ? dropdownFilters : this.principalAmortizationGridStore.gridData.meta.dropdownFilters
      );
    } catch (error) {
      if (error?.error?.response?.status == 400) {
        this.globalStore.notificationStore.showWarningNotification({
          message: error?.error?.response?.data?.error?.message,
        });
      } else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'Error while fetching data.',
        });
      }
    }
  };

  setTab(tab: PrincipalAmortizationTabs) {
    this.tab = tab;
  };

  setLoan(value) {
    this.loan = value;
  }

  resetToolbarInfo() {
    this.setLoan({});
  }
}